import { Effect, Exit, Option, Schema } from 'effect';

import { CreateOrderDidNotReturnToken } from '@vs-shop/engine/data/error/generic';
import { createOrder } from '../../bind/orderRequests';
import { OrderToken } from '../../service/orderToken/OrderToken';

const TokenSchema = Schema.NonEmptyString;

export const getOrCreateOrderToken = Effect.gen(function* () {
  const orderTokenService = yield* OrderToken;

  const existingTokenOption = yield* orderTokenService.getToken;

  if (Option.isSome(existingTokenOption)) {
    return existingTokenOption.value;
  }

  const orderResponse = yield* createOrder.pipe(
    Effect.mapError(
      (error) =>
        new CreateOrderDidNotReturnToken({
          message: 'Failed to create order',
          cause: error,
        })
    )
  );

  const tokenValidation = Schema.decodeUnknownExit(TokenSchema)(orderResponse.tokenValue);
  if (Exit.isFailure(tokenValidation)) {
    return yield* new CreateOrderDidNotReturnToken({
      message: 'Order API did not return valid token',
      cause: tokenValidation.cause,
    });
  }

  const token = tokenValidation.value;

  yield* orderTokenService.setToken(token);

  return token;
});
